export default "__VITE_ASSET__7TOH$h9V__"